export type DomainErrorConfiguration = {
    recoverable: boolean;
};

const DOMAIN_ERROR_TYPE = 'DomainError';

export abstract class DomainError extends Error {
    name = DOMAIN_ERROR_TYPE;

    constructor(
        message: string,
        private readonly configuration: DomainErrorConfiguration = {
            recoverable: false,
        }
    ) {
        super(message);

        Error.captureStackTrace?.(this, this.constructor);
        this.name = this.constructor.name;
    }

    get recoverable() {
        return this.configuration.recoverable;
    }
}
